<template>
    <div class="container">

    <!-- 标题 -->
    <div class="header-title">
        <div class="tag-title">第一层</div>
        <h1 class="main-title">整场考试画像（宏观决策）</h1>
    </div>

    <!-- 内容 -->

    <div class="card-row">
        <div
            class="stat-card"
            :class="item.className"
            v-for="item in cardList"
            :key="item.title"
        >
            <div class="card-title">{{ item.title }}</div>
            <div class="card-value">{{ item.value }}</div>
            <div class="card-desc" :class="{ red: item.isRed }">
            {{ item.desc }}
            </div>
        </div>
    </div>



    <div class="header-title">
        <div class="tag-title">第二层</div>
        <h1 class="main-title">班级质量分析</h1>
    </div>

    <!-- {{ configHard }} -->

    <el-tabs type="border-card" v-model="activeTab">
      <el-tab-pane 
        v-for="item in configHard" 
        :key="item.hard_class_id"
        :label="item.hard_name"
        :name="item.hard_name"
      >
      <div style="display: flex; gap: 20px; align-items: flex-start;"></div>

      <div class="card-row">
        <div
            class="stat-card"
            :class="item.className"
            v-for="item in cardList"
            :key="item.title"
        >
            <div class="card-title">{{ item.title }}</div>
            <div class="card-value">{{ item.value }}</div>
            <div class="card-desc" :class="{ red: item.isRed }">
            {{ item.desc }}
            </div>
        </div>
      </div>


      </el-tab-pane>
    </el-tabs>

    <!-- 图表 -->
    <div class="chart-row">

        <!-- 成绩分布直方图 -->
        <div class="chart-card">
            <h3 class="chart-title">成绩分布直方图</h3>
            <div ref="score" class="chart-container"></div>
        </div>

        <!-- 学业等级结构 -->
        <div class="chart-card">
            <h3 class="chart-title">学业等级结构（A/B/C/D/E）</h3>
            <div ref="studentLevel" class="chart-container"></div>
        </div>

    </div>

    <div  class="chart-row">
        <div class="chart-card-full">
            <h3 class="chart-title">与年级对比分析</h3>
            <div ref="compare" class="chart-container"></div>
        </div>
    </div>






    </div>
</template>

<script>
  import {mapGetters, mapState} from "vuex";
  import * as simpleApi from "request/simple";
  import XEUtils from 'xe-utils'
  import * as mUtils from '@/utils/mUtils'
  import * as echarts  from 'echarts';
  import { ref } from 'vue'

  export default {
      name: 'teacherDialog',
      data(){
        return {
          // 班级列表
          tableData: [],
          cardList: [
            {
                title: "班级均分",
                value: "62.7",
                desc: "↓ 低于年级均分 1.82分",
                className: "card-blue",
                isRed: true
            },
            {
                title: "最高分",
                value: "129.5",
                desc: "粟辉艳（年级第1名）",
                className: "card-green",
                isRed: false
            },
            {
                title: "最低分",
                value: "8.0",
                desc: "需重点关注（2人并列）",
                className: "card-red",
                isRed: true
            },
            {
                title: "标准差",
                value: "28.4",
                desc: "成绩离散程度较大",
                className: "card-blue",
                isRed: false
            },
            {
                title: "及格率",
                value: "58%",
                desc: "低于年级平均6个百分点",
                className: "card-yellow",
                isRed: true
            },
            {
                title: "优秀率（≥90）",
                value: "16%",
                desc: "8人达到优秀水平",
                className: "card-green",
                isRed: false
            }
            ],
          loading: false,
          // json 数据
          jsonData: null,
          // json 文件中过滤出的中行政班
          hardClassList:[],
          // 班级统计信息
          hardClassStatistics: null,
          // 老师配置的总的行政班(读取老师旗下指定课程的行政班列表)
          hardClassConfig:[],
          // 过滤后该老师在这场考试的的行政班
          configHard:[],
          scoreRange: ['优秀','良好','中等','及格','不及格'], 
          scoreLevels: {
            score90: {name: '优秀', from: 90, to: 100}, 
            score80: {name: '良好', from: 80, to: 90},
            score70: {name: '中等', from: 70, to: 80},
            score60: {name: '及格', from: 60, to: 70}, 
            score0: {name: '不及格', from: 0, to: 60},
          },
          activeTab: null,

        }
      },
      components:{
      },
      computed:{
          ...mapState({
              userInfo: state => state.user.userInfo,
          }),
      },
      mounted() {
       
      },
      props: {
        examId: {
            type: Number
        },
      },
      watch: {

      },
      created(){
        this.loadMyClassList()
        this.loadExamCtrl()


      },
      methods: {
       // 加载整场考试json数据
        // 获取analyse.json并解析
        loadExamCtrl(callback){
          let analyse_oss_name = "answer/analyse/"  + this.examId + "/exam_analyse_" + this.examId +".json"
          if(analyse_oss_name != null){
              analyse_oss_name = window.g.OSS_HOST + analyse_oss_name;
          }

          this.loading = true;
          let that = this;

          axios.defaults.headers = {'Content-Type': 'application/json;charset=UTF-8'}
          axios({
              method:'get',
              url: `${analyse_oss_name}?t=${Date.now()}`
            }).then((res)=>{

                this.jsonData = res.data

                let data = res.data;
                // 年段平均分
                // let gradeAvg = data.score_avg
                
                // 年段总分
                let gradeFullScore = data.full_score
                // 每个班级各分数段列表(平均，优秀...)
                let hard_score_count = data.hard_score_count
                // 每个班级统计数据（包含最高分，最低分，各分数段等）
                let hard_scores =data.hard_scores

                // 获取该考试总的行政班信息
                this.getInfo(hard_scores)



                // 过滤此老师名下的行政班
                this.filterHardClassConfig()

                // this.loadingTiJson()

                if(callback) callback()
                else that.loading = false;
            }).catch((error) => {
                that.loading = false;
            });

        },
        // 计算
        getInfo(hardScores){
          // 针对每个班级整合统计信息
          let hardClass = []
          hardScores.forEach((item,index) => {

            // 获取班级信息
            let hardName = item['hardName']
            hardClass.push({
              hardName: hardName,
              index: index
            })
            // 根据获得每个等级的人数
            let scores = item.scores
            let level = this.getScoreNums(item)
            item.scoreLevels = level

          });

          this.hardClassList = hardClass

          this.hardClassStatistics = hardScores
        },
        // 排序不同等级的人数
        getScoreNums(item){
          let scoreLevels = this.scoreLevels 
          let scores = item.scores
          let level = []
          Object.keys(scoreLevels).forEach(key => {
              // console.log('键:', key);
              // console.log('值:', scoreLevels[key]);
              let form = scoreLevels[key].from
              let to = scoreLevels[key].to
              let count = 0
              scores.forEach(ele => {
                if(ele.score >= form && ele.score < to){
                  count = count + ele.count;
                }
              });
              // 每个等级的人数（当前班级）
              let param = Object.assign({}, scoreLevels[key]);
              param.count = count
              level.push(param)
          });
          return level


        },
        // 过滤配置班级
        filterHardClassConfig(){
          // 将考试json中的行政班与该老师的行政班进行比对，只显示老师配置的行政班
          let configHard = this.hardClassConfig.filter(item1 => 
            this.hardClassList.some(item2 => item2.hardName === item1.hard_name)
          )
          this.configHard = configHard
        },

        // 读取老师旗下指定课程的行政班列表
        loadMyClassList(){
          let search = {  teacherId: this.userInfo.id};
          let param = { controllerName: 'teacherMyClass', methodName: '/myClassListAll',  param: search};
          return simpleApi.list(param).then(({result: {code, data}}) =>  {
            if (code == 0) {
              this.hardClassConfig = data
            }
          }).catch((error) => {
              console.log("error",error)
          });
        },

        // 分数段比较表
        step10Chart(){

            // 将考试json中的行政班与该老师的行政班进行比对，只显示老师配置的行政班
            let configHard = this.hardClassConfig.filter(item1 => 
              this.hardClassList.some(item2 => item2.hardName === item1.hard_name)
            )
            this.configHard = configHard
            
            if(configHard.length == 0)  return 

            let chartList = []
            configHard.forEach((ele,count) => {
              let hardName = ele.hard_name
              let item = this.hardClassList.find(item => item.hardName == hardName)
              let index = item.index
              // 获取当前选中的班级
              let legendHard = hardName + "分数段"
              let hardStep10 = this.hardClassStatistics[index].step10
              let gradeStep10 = this.jsonData.score_step10

              // 过滤排序
              let hardClassSort = hardStep10.map(item => item.count)
              let gradeSort  = gradeStep10.map(item => item.count)

              let option = {
                  index: count,
                  hardName: hardName,
                  legendHard : legendHard,
                  hardStep10: hardStep10,
                  gradeSort: gradeSort,
                  hardClassSort: hardClassSort
                }
                chartList.push(option)
            })

            this.chartList = chartList
            // 初始化多张图表
            this.initStep10Chart(chartList)

            },
            // 分数段比较表初始化
            initStep10Chart(chartList){

            chartList.forEach((ele,index) => {
              let chartDom = this.$refs[`chart_${index}`]
              if (chartDom && chartDom[0]) {
                let chart = echarts.init(chartDom[0])
                // 配置项
                let option = {
                  title: {
                    text: ele.hardName + '各类指标比对',  
                  },
                  // 触发方式：'axis'坐标轴触发，'item'数据项触发
                  tooltip: {
                    trigger: 'axis'  
                  },
                  // X轴配置
                  xAxis: [
                    {
                      // 类目轴，适用于离散的类目数据
                      type: 'category',  
                      // 配置X轴名称
                      data: this.step10List
                    }
                  ],
                  // Y轴配置
                  yAxis: [
                    {
                      // 数值轴，适用于连续数据
                      type: 'value'  
                    }
                  ],
                  // 图例项，对应series中的name
                  legend: {
                    data: [ele.legendHard, '年级分数段']  
                  },
                  // 数值列表
                  series: [
                    {
                      // 系列名称，与legend对应
                      name: ele.legendHard,
                      // 图表类型：柱状图
                      type: 'bar', 
                      // 数据数组 
                      data: ele.hardClassSort,
                      itemStyle: {
                        color: '#90cbfb'
                      },
                      barGap: '10%', 
                    },{
                        name: '年级分数段',      
                        type: 'bar',           
                        data: ele.gradeSort, 
                        itemStyle: {
                          color: '#d2e682'
                        },
                        barGap: '10%', 
                    }
                  ]
                }

                // 设置配置项并渲染
                chart.setOption(option);

              }
            })

            },
      }
    }
</script>

<style lang="scss" type="text/scss" rel="stylesheet/scss">

  .container {
    padding: 20px;
    background-color: #ffffff;
    font-family: -apple-system, BlinkMacSystemFont, 'Segoe UI', Roboto, 'Helvetica Neue', Arial, sans-serif;
  }

  /* 标题栏 */
  .header-title {
    display: flex;
    align-items: center;
    border-bottom: 2px solid #3b82f6;
    padding-bottom: 10px;
    margin-bottom: 20px;
    margin-top: 20px;
  }

  .tag-title {
    background-color: #3b82f6;
    color: #ffffff;
    padding: 4px 12px;
    border-radius: 8px;
    font-size: 14px;
    font-weight: 600;
    margin-right: 12px;
  }
  
  .main-title {
    font-size: 24px;
    font-weight: 700;
    color: #1e293b;
    margin: 0;
  }

  /* 数据卡片行 */
  .card-row {
    display: flex;
    gap: 16px;
    margin-bottom: 24px;
  }
  
  .stat-card {
    flex: 1;
    background-color: #f8fafc;
    border-radius: 8px;
    padding: 20px;
    border-left: 4px solid;
  }
  
  /* 卡片边框颜色 */
  .card-blue { border-left-color: #3b82f6; }
  .card-green { border-left-color: #10b981; }
  .card-red { border-left-color: #ef4444; }
  .card-yellow { border-left-color: #f59e0b; }

  .card-title {
    font-size: 16px;
    color: #475569;
    margin-bottom: 8px;
    font-weight: 500;
  }
  
  .card-value {
    font-size: 32px;
    font-weight: 700;
    color: #1e293b;
    margin-bottom: 8px;
  }
  
  .card-desc {
    font-size: 14px;
    color: #64748b;
    line-height: 1.5;
  }
  
  .card-desc.red {
    color: #ef4444;
  }


  /* 图表行 */
 .chart-row {
    display: flex;
    gap: 20px;
  }
  
  .chart-card {
    flex: 1;
    background-color: #fafafa;
    border-radius: 8px;
    padding: 16px;
  }
  
  .chart-title {
    text-align: left; 
    font-size: 18px;
    font-weight: 600;
    color: #1e293b;
    margin: 0 0 16px 0;
  }
  
  .chart-container {
    width: 100%;
    height: 300px;
  }

  // 独占整个图表区域
  .chart-card-full {
    flex: 1;       
    width: 100%;
    background: #fff;
    border-radius: 8px;    /* 圆弧 */
    box-shadow: 0 2px 12px rgba(0, 0, 0, 0.1);  /* 阴影 */
    padding: 16px;
    }

</style>